import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useState, Fragment } from "react";
import { useBanner } from "../../contexts";
import { BannerButtonsInlineStyles } from ".";

var BannerButton = function BannerButton(_ref) {
  var inlineStyle = _ref.inlineStyle,
      type = _ref.type,
      onClick = _ref.onClick,
      children = _ref.children,
      framed = _ref.framed;

  if (type === "hide") {
    return null;
  }

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHover = _useState2[0],
      setIsHover = _useState2[1];

  var banner = useBanner();
  var interactionAttr = {
    onClick: onClick,
    onMouseEnter: function onMouseEnter() {
      return setIsHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHover(false);
    }
  }; // Also create a spacing `height:10` container because `marginBottom` causes issues with `position:sticky`

  return h(Fragment, null, h("div", _extends({}, type === "button" ? interactionAttr : {}, BannerButtonsInlineStyles[inlineStyle](banner, isHover, framed)), h("span", type === "link" ? _objectSpread(_objectSpread({}, interactionAttr), {}, {
    style: {
      cursor: "pointer"
    }
  }) : {}, children)), h("div", {
    style: {
      height: 10
    }
  }));
};

export { BannerButton };